import { PromotionCardDataType } from "../../interfaces/PromotionCard";
import useAppStore from "../../store/AppStore";
import PromotionCardGroup from "./desktopPromotionGroup/PromotionCardGroup";
import PromotionCardGroupMobile from "./mobilePromotionGroup/PromotionCardGroupMobile";

export default function PromotionCardGroupContainer({
  data,
}: {
  data: PromotionCardDataType;
}) {
  const { isDeviceMobile } = useAppStore();
  return (
    <>
      {isDeviceMobile ? (
        <PromotionCardGroupMobile data={data} />
      ) : (
        <PromotionCardGroup data={data} />
      )}
    </>
  );
}
